<template>
  <!-- <div class="ticket-layout"> -->
  <div>
    <load-profile />
    <template>
      <!-- <div
        :class="
          ticketStore.toggleLeftSidebar
            ? 'ticket-left-layout__active'
            : 'ticket-left-layout__inactive'
        "
        tabindex="0"
        @scroll="onScroll"
        @focusout="handleFocusOut"
      >
        <LeftSide />
      </div> -->
      <div class="ticket-center-main">
        <ListBot />
      </div>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useTicketStore from "@/store-pinia/useTicketStore";
import useWidth from "@/composibles/useWidth";
import { watch } from "@vue/composition-api";
import useRoleStore from "@/store-pinia/useRoleStore";
import useJwt from "@/auth/jwt/useJwt";
import ListBot from "@/views/bot/List.vue";
import LeftSide from "@/views/bot/Create.vue";

export default {
  components: {
    ListBot,
    LeftSide,
  },
  data: () => ({
    socket: null,
  }),
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },

  created() {
    console.log("userdata", this.userData);
  },

  setup() {
    const { windowWidth } = useWidth();
    const ticketStore = useTicketStore();
    const roleStore = useRoleStore();


    // onMounted(() => {
    //   if (windowWidth <= 1000 && windowWidth > 1000) {
    //     ticketStore.setToggleLeftSidebar(false)
    //     ticketStore.setToggleRightSidebar(false)
    //   } else if
    //   // Screen larger than 1000
    //   (windowWidth > 1000 && windowWidth <= 1000) {
    //     ticketStore.setToggleLeftSidebar(true)
    //     // ticketStore.setToggleRightSidebar(true)
    //   }
    // })

    watch(
      windowWidth,
      (newVal, oldVal) => {
        // Screen lower than 1000
        if (newVal <= 1000 && oldVal > newVal) {
          ticketStore.setToggleLeftSidebar(false);
          ticketStore.setToggleRightSidebar(false);
        } else if (
          // Screen larger than 1000
          newVal > 1000 &&
          oldVal < newVal
        ) {
          ticketStore.setToggleLeftSidebar(true);
          // ticketStore.setToggleRightSidebar()
        }
      },
      {
        immediate: true,
      }
    );

    const updateScrollOffSet = 10;
    function onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (
        scrollTop + clientHeight + (scrollHeight * updateScrollOffSet) / 100 >=
        scrollHeight
      ) {
        console.log("Reach Bottom Div, Get More Ticket 🚀 if it not total");
        if (ticketStore.tickets.length < ticketStore.ticketTotal)
          ticketStore.getTicketsInfiniteAsync();
      }
    }
    const handleFocusOut = () => {
      console.log("focus out");
    };
    return {
      onScroll,
      ticketStore,
      windowWidth,
      handleFocusOut,
      roleStore
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-layout {
  position: relative;
  display: flex;
  //display: grid;
  //grid-template-columns: 0fr 3fr 1fr;
  height: calc(
    var(--vh, 1vh) * 100 -
      calc(calc(2rem * 1) + 4.45rem + 3.35rem + 1.3rem + 0rem)
  );
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
  overflow: hidden;

  @media (max-width: 1000px) {
    //grid-template-columns: 0fr 3fr;
  }

  .max-height {
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .ticket-left-layout {
    @extend .max-height;
    border-right: 1px solid #ebe9f1;

    transition: all 0.3s ease-in-out;

    @media (max-width: 1000px) {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 100%;
      background: white;
      z-index: 1;
    }
  }

  .ticket-left-layout__active {
    @extend .ticket-left-layout;
    //transition: all 0.3s ease-in-out;
    width: 400px;
    flex: 1.5;
    opacity: 1;
    z-index: 10;

    //.ticket-left-sidebar{
    //  opacity: 1;
    //}
  }
  .ticket-left-layout__inactive {
    @extend .ticket-left-layout;
    //transition: all 0.3s ease-in-out;
    width: 0;
    flex: 0;
    opacity: 0;
    z-index: 10;

    //.ticket-left-sidebar{
    //  opacity: 0;
    //}
  }

  .ticket-center-layout {
    background: #f2f0f7;
    @extend .max-height;
  }

  .ticket-center-main {
    //@media (min-width: 1300px){
    //  flex: 2
    //}
    flex: 3;
  }

  .ticket-right-layout {
    @extend .max-height;
    border-left: 1px solid #ebe9f1;
    transition: all 0.3s ease-in-out;

    @media (max-width: 1000px) {
      position: absolute;
      right: 0;
      height: 100%;
      background: white;
      z-index: 10;
    }
  }
  .ticket-right-layout__active {
    @extend .ticket-right-layout;
    opacity: 1;
    max-width: 400px;
    flex: 1.5;
  }
  .ticket-right-layout__inactive {
    @extend .ticket-right-layout;
    opacity: 0;
    max-width: 0;
    flex: 0;
  }
}
.ticket-layout--open-right-sidebar {
  @extend .ticket-layout;
  //grid-template-columns: 1.25fr 2fr 1.25fr;

  //grid-template-columns: 1.5fr 3fr 1.5fr;
  @media (max-width: 1000px) {
    //grid-template-columns: 0fr 3fr;
  }
}
.ticket-layout--close-right-sidebar {
  @extend .ticket-layout;
  //grid-template-columns: 1.5fr 4.5fr 0fr;
  @media (max-width: 1000px) {
    //grid-template-columns: 0fr 3fr 0fr;
  }
}
.overlay-content {
  @media (max-width: 1000px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(47, 47, 47, 0.2);
    border-radius: 0.1785rem;
    z-index: 1;
  }
}
</style>
